import styles from './A_CostResult.module.css';
import cn from 'classnames';

interface A_CostResultProps {
  number: number;
  text: string;
  isDiscounted: boolean;
}

const getValueWithSymbol = (value: number, isDiscounted: boolean) => {
  if (isDiscounted) {
    return `${value}%`;
  }
  return `${value} $`;
};

const shouldApplyDiscountedClass = (number: number, isDiscounted: boolean) => {
  return isDiscounted && number !== 0;
};

export default function A_CostResult({
  number,
  text,
  isDiscounted,
}: A_CostResultProps) {
  return (
    <div className={styles.wrapper}>
      <span className={cn(styles.text, 'text-p-6')}>{text}</span>
      <div className={styles.divider}></div>
      <span
        className={cn(
          styles.number,
          {
            [styles.discounted]: shouldApplyDiscountedClass(
              number,
              isDiscounted
            ),
          },
          'text-p-6'
        )}
      >
        {getValueWithSymbol(number, isDiscounted)}
      </span>
    </div>
  );
}
